module.exports = __webpack_public_path__ + "static/img/sjoa.efadbb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sjoa.png
// module id = pGlB
// module chunks = 0